import { render, staticRenderFns } from "./CollectDataList.vue?vue&type=template&id=046ac759&"
import script from "./CollectDataList.vue?vue&type=script&lang=js&"
export * from "./CollectDataList.vue?vue&type=script&lang=js&"
import style0 from "./CollectDataList.vue?vue&type=style&index=0&id=046ac759&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports